import React from 'react';
import FailBackground from "../../assets/images/FailBackground.png";
import FailImg from "../../assets/images/FailImg.png";

const FailIconDisplay = React.memo(() => {
    return (
        <>
            <figure className="absolute z-10">
                <img alt='' className="w-full" src={FailBackground} />
            </figure>
            <figure className="absolute z-10">
                <img alt='' className="w-full" src={FailImg} />
            </figure>
        </>
    );
});

export default FailIconDisplay;
